"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.controller = void 0;
var tslib_1 = require("tslib");
var WebViewController_1 = require("./WebViewController");
var WKWebViewController_1 = require("./WKWebViewController");
var userAgent = navigator.userAgent;
var isVRWebView = /realsee/i.test(userAgent);
var EmptyController = /** @class */ (function () {
    function EmptyController() {
    }
    EmptyController.prototype.checkReady = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                return [2 /*return*/, [false, null]];
            });
        });
    };
    EmptyController.prototype.callAndBackfeed = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                return [2 /*return*/, [false, null]];
            });
        });
    };
    EmptyController.prototype.callAndListen = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                return [2 /*return*/, [function () { return undefined; }, null]];
            });
        });
    };
    return EmptyController;
}());
exports.controller = isVRWebView ? (/android/i.test(userAgent) ? new WebViewController_1.WebViewController() : new WKWebViewController_1.WKWebViewController()) : new EmptyController();
//# sourceMappingURL=index.js.map